if (!customElements.get("sq-collection-filter")) {
  class SQCollectionFilter extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    
    connectedCallback() {
      // Remove initSwipers call from here since it's now in init()
    }

    init() {
      this.selectors = {
        filterBtn: this.querySelector('.show-more-button'),
        filterItems: this.querySelectorAll('.m-filter--widget-content .m-facets li.m-facet--item'),
        filterTitle: this.querySelector('.m-filter--widget-title'),
        filterContent: this.querySelector('.m-filter--widget-content')
        
      };
      if (this.selectors.filterBtn) {
        this.selectors.filterBtn.addEventListener('click', () => {
          if (this.selectors.filterBtn.dataset.open === 'false') {
            this.selectors.filterBtn.dataset.open = 'true';
            this.selectors.filterBtn.innerHTML = 'Show Less';
            this.selectors.filterItems.forEach(item => {
              item.style.display = 'block';
            });
          } else {
            this.selectors.filterBtn.dataset.open = 'false';
            this.selectors.filterBtn.innerHTML = 'Show More';
            this.selectors.filterItems.forEach((item, index) => {
              item.style.display = index < 10 ? 'block' : 'none';
            });
          }
          // Calculate the max height of the filter content
          let contentMaxHeight =  this.selectors.filterTitle.offsetHeight + this.selectors.filterBtn.offsetHeight;
          for (let i = 0; i < this.selectors.filterItems.length; i++) {
            if (this.selectors.filterItems[i].style.display === 'block') {
              contentMaxHeight += this.selectors.filterItems[i].offsetHeight;
            }
          }
          this.style.setProperty('--content-max-height', `${contentMaxHeight}px`);
        });
      }
    }
  }

  customElements.define("sq-collection-filter", SQCollectionFilter);
}